export const submitHiddenForm = (
    method: 'post',
    url: string,
    formData: Record<string, string | null | undefined>,
) => {
    const form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', url);

    Object.entries(formData).forEach(([name, value]) => {
        if (typeof value === 'string') {
            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', name);
            hiddenField.setAttribute('value', value);

            form.appendChild(hiddenField);
        }
    });

    document.body.appendChild(form);
    form.submit();
};
